import { render, staticRenderFns } from "./NotificationCardForEventComment.vue?vue&type=template&id=5ebfcc9f&scoped=true&"
import script from "./NotificationCardForEventComment.vue?vue&type=script&lang=js&"
export * from "./NotificationCardForEventComment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ebfcc9f",
  null
  
)

export default component.exports